export default __webpack_public_path__ + "static/media/type_12_6.31fcdf80.svg";